/**
 * Fullscreen video component.
 * Plays videos on fullscreen overlay when they should autoplay. Some autoplay attributes work fine in browsers, but this will ensure full browser compatibility.
 *
 * Methods:
 *
 * init(): init listener for fullscreen video
*/

const Modal = require('./modal.js');

// Plays video if it is visible, pauses it otherwise
const setPausePlay = ($video) => {
	if ($video.clientHeight === 0 && $video.clientWidth === 0) {
		$video.pause();
	} else {
		$video.play();
	}
}

const init = () => {
	// Get all fullscreen video modals
	const $videosFullscreen = document.querySelectorAll('.js-video-modal-fullscreen');

	// Loop over found modals
	$videosFullscreen.forEach($videoModal => {
		// Get all 'video' elements inside modal
		const $videos = $videoModal.querySelectorAll('video');
		// Get close button of modal
		const $closeBtn = $videoModal.querySelector('.modal-close');
		// Add listener to close button for pausing video when closed
		if ($closeBtn) $closeBtn.addEventListener('click', () => {
			$videos.forEach($video => {
				$video.pause();
			});
		});

		// Get value of ID attribute of modal
		const modalId = $videoModal.getAttribute('id');
		// Get triggers for this video modal to open
		document.querySelectorAll(`[href="#${modalId}"]`).forEach($a => {
			// Add listener to trigger
			$a.addEventListener('click', () => {
				// Open modal using Modal component
				Modal.openModal(modalId);

				// Loop over all video tags and play visible video
				$videos.forEach($video => {
					setPausePlay($video);
				});
			});
		});
	});
};

module.exports = {
	init
};
